/**
 * Load more button for archive page.
 */
jQuery( $ => { // use jQuery code inside this to avoid "$ is not defined" error
	let currentPage,
		loadingText,
		seeMoreText;
	$( '.ac-loadmore' ).on( 'click', function( event ) {
		// prevent click event on the button
		event.preventDefault();
		const button = $( this );
		button.attr( 'disabled', true );
		loadingText = button.data( 'loading' );
		seeMoreText = button.text();
		const { posts, ajaxurl, maxPage } = acLoadmoreParams; // eslint-disable-line no-undef
		if ( ! currentPage ) {
			currentPage = acLoadmoreParams.currentPage; // eslint-disable-line no-undef
		}
		const dataObject = {
			action: 'loadmore',
			query: posts,
			page: currentPage,
		};

		$.ajax( {
			url: ajaxurl,
			data: dataObject,
			type: 'POST',
			beforeSend: () => {
				button.text( loadingText ); // change the button text, you can also add a preloader image
			},
			success: result => {
				if ( result ) {
					$( '.archive-loadmore-container' ).append( result );
					currentPage++;
					button.text( seeMoreText );
					if ( currentPage >= maxPage ) {
						button.remove();
					} // if last page, remove the button
				} else {
					button.remove(); // if no data, remove the button as well
				}
			},
			complete: () => {
				button.attr( 'disabled', false );
			},
		} );
	} );
} );
